import { Component } from '@angular/core';

@Component({
  selector: 'swotify-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Auxswot Education';
}
